enum ANCHOR {
  HOME = '/',
  NEWSLETTER_THANK_YOU_PAGE = '/thank-you'
}

export default ANCHOR;
